import React, { useState } from "react";

import { returnMoreItems } from "../../../../services/api";
import { Select } from "../../../../../ui-kit/components/Select";
import { Typography } from "../../../../../ui-kit/components/Typography/Typography";

export const UnregisteredItem = ({
  t,
  unregistered_items,
  customer_return,
  setStateOfCustomerReturn,
}) => {
  const [isOpen, setOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState(
    unregistered_items.map((item) => ({
      ...item,
      addedQuantity: 1,
      selected: false,
    }))
  );

  function updateItem(i, data) {
    setSelectedItems((old) => {
      const arr = [...old];
      arr[i] = { ...arr[i], ...data };
      return arr;
    });
  }

  function quantityOptions(max) {
    const options = [];
    for (let i = 1; i <= max; i++) options.push({ label: i, value: String(i) });
    return options;
  }

  function cancelAddingMoreItems() {
    setOpen((prev) => {
      !prev.isOpen;
    });
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    const selected = selectedItems
      .filter((item) => item.selected)
      .map((item) => ({
        sku: item.shop_line_item_id,
        quantity: Number(item.addedQuantity),
      }));

    const payload = {
      customer_return: {
        items: selected,
      },
    };

    try {
      const response = await returnMoreItems(customer_return.id, payload);

      if (response.ok) {
        const responseJson = await response.json();
        const items = responseJson.customer_return.items;

        setSelectedItems((prevItems) => {
          const updatedItems = prevItems.filter((item) => {
            const updatedItem = items.find(
              (newItem) =>
                newItem.shop_line_item_id === item.shop_line_item_id &&
                item.quantity === newItem.quantity
            );
            return !updatedItem; // Keep only items that haven't been updated
          });

          // Check if there are any unselected items left
          if (updatedItems.length === 0) {
            setOpen(false);
          }

          return updatedItems;
        });

        setStateOfCustomerReturn(responseJson.customer_return);
      } else {
        console.error(
          "Failed to submit return items. Status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };

  return (
    <>
      {selectedItems.length > 0 && (
        <div className="flex mt-8">
          <button
            className="bg-white border-blue-675 mt-5 border rounded-lg font-semibold text-xs14 leading-5 text-blue-675 px-4 py-2 focus:outline-none hover:bg-blue-625 hover:text-white focus:shadow-btn_blue"
            onClick={() => setOpen(!isOpen)}
          >
            <span>+ {t.more_items}</span>
          </button>
        </div>
      )}
      {isOpen && (
        <div className="mt-8">
          {selectedItems.map((item, i) => (
            <div
              key={item.shop_line_item_id}
              className={
                "flex items-center justify-between py-4 gap-x-4" +
                (i ? " border-t" : "")
              }
            >
              <input
                className="cursor-pointer h-6 w-6 rounded"
                id="customAddress"
                name="customAddress"
                type="checkbox"
                onChange={() => updateItem(i, { selected: !item.selected })}
                checked={item.selected}
                disabled={item.added}
              />
              <div className="w-full image-container-center">
                <div className="flex items-center justify-center w-72px h-72px border rounded">
                  <img
                    alt={item.name}
                    className="max-h-70px transform"
                    src={item.image_url}
                  />
                </div>

                <div className="flex ml-6 gap-4 items-center">
                  <div className="w-full">
                    <Typography
                      element="p"
                      weight="semibold"
                      size="xs"
                      height="4"
                      color="gray-825"
                      className="flex-1"
                    >
                      {item.name}
                    </Typography>

                    {(item.rma || item.ean || item.sku || "") && (
                      <div className="mt-1">
                        {item.rma && (
                          <div className="flex gap-x-3 w-full">
                            <Typography
                              element="p"
                              weight="medium"
                              size="xs"
                              height="4"
                              color="gray-725"
                            >
                              {t.rma}
                            </Typography>
                            <Typography
                              element="p"
                              weight="normal"
                              size="xs"
                              height="4"
                              color="gray-625"
                            >
                              {item.rma}
                            </Typography>
                          </div>
                        )}

                        {item.sku && (
                          <div className="flex gap-x-3">
                            <Typography
                              element="p"
                              weight="medium"
                              size="xs"
                              height="4"
                              color="gray-725"
                            >
                              SKU
                            </Typography>
                            <Typography
                              element="p"
                              weight="normal"
                              size="xs"
                              height="4"
                              color="gray-625"
                            >
                              {item.sku}
                            </Typography>
                          </div>
                        )}

                        {item.ean && (
                          <div className="flex gap-x-3">
                            <Typography
                              element="p"
                              weight="medium"
                              size="xs"
                              height="4"
                              color="gray-725"
                            >
                              EAN
                            </Typography>
                            <Typography
                              element="p"
                              weight="normal"
                              size="xs"
                              height="4"
                              color="gray-625"
                            >
                              {item.ean}
                            </Typography>
                          </div>
                        )}
                      </div>
                    )}
                  </div>

                  {item.quantity > 1 && (
                    <div>
                      <Select
                        className="w-20 bg-white box-border rounded-lg border focus:outline-none py-px px-px font-medium text-sm leading-5 text-gray-875 focus:border-blue-675 focus:border capitalize"
                        onChange={(addedQuantity) =>
                          updateItem(i, { addedQuantity })
                        }
                        options={quantityOptions(item.quantity)}
                        value={item.addedQuantity.toString()}
                        isDisabled={!item.selected}
                        placeholder=""
                      />
                    </div>
                  )}

                  <div>
                    <Typography
                      element="p"
                      weight="semibold"
                      size="lg"
                      height="6"
                      color="gray-825"
                      className="flex-grow text-right font-clash_grotesk"
                    >
                      {new Intl.NumberFormat("en", {
                        style: "currency",
                        currency: item.currency,
                      }).format(item.amount)}
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
          ))}

          <div className="flex mt-5 gap-x-3">
            <button
              className="bg-white bg-blue-675 border-blue-675 border rounded-lg font-semibold text-xs14 leading-5 text-white px-4 py-2 focus:outline-none hover:bg-blue-625 hover:text-white focus:shadow-btn_blue"
              name="add_selected_items"
              onClick={handleSubmit}
            >
              {t.add_items}
            </button>
            <button
              className="bg-white border-blue-675 border rounded-lg font-semibold text-xs14 leading-5 text-blue-675 px-4 py-2 focus:outline-none focus:shadow-btn_blue hover:bg-blue-625 hover:text-white"
              name="cancel"
              onClick={cancelAddingMoreItems}
            >
              {t.cancel_add}
            </button>
          </div>
        </div>
      )}
    </>
  );
};
